import { Component, OnInit, ViewChild, Injectable } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { Observable } from "rxjs";
import { UntypedFormControl } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { LmsService } from "../../_Lms/services/lms.service";
import { Router } from "@angular/router";
declare var $: any;
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { DialogService } from "../../Shared/dialog.service";
import { map, startWith } from "rxjs/operators";
import { ToWords } from "to-words";
import { MasterService } from "../../Shared/app.Masters.Service";
import * as moment from "moment";
import { ActivatedRoute, Params } from "@angular/router";
import { ReportsService } from "../../_Reports/services/reports.service";

@Component({
  selector: 'app-cash-flow-data',
  templateUrl: './cash-flow-data.component.html',
  styleUrls: ['./cash-flow-data.component.scss']
})
export class CashFlowDataComponent implements OnInit {
  showSpinner: boolean = false;
  FromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  ToDate: any = new Date();
  configSuccess: MatSnackBarConfig = {
      panelClass: "style-success",
      duration: 5000,
      horizontalPosition: "right",
      verticalPosition: "top",
    };
  DataSource: any;
  dataSourcemodel: any;
  dataSourceExcelmodel: any;
@ViewChild('matSort1') matSort1: MatSort;
  @ViewChild('matpaginatorref') matpaginatorref: MatPaginator;
  @ViewChild('modelSort') modelSort: MatSort;
  @ViewChild('modelPaginator') modelPaginator: MatPaginator;
  DataSourcetop: any;
    FyearId: any;
  maxDate: any;
  minDate: any;
  displayedColumns: string[] = [
    "AccountId",
    "Account_Name",
    "Group_Name",
    "UpperGroupName",
    "Opening_Balance",
    "Closing_Balance",
    "ChangeInMomentSource",
    "ChangeInMomentApplication",
    "NonMomentFund",
    "Action",
  ];
  displayedColumnsmodel: string[] = [
    "voucherid",
    "VoucherDate",
    "Voucher_No",
    "CaseNo",
    "accHead",
    "TranTypeDR",
    "TranTypeCR",
    "TranTypeTotal",
    "Narration"
  ];
  IncreaseInApplicationOfFund: any;
  DecreaseInApplicationOfFund: any;
  IncreaseInSourceOfFund: any;
  DecreaseInSourceOfFund: any;
  FileCheckingList: any[] = [];
  FileCheckingList1: any[] = [];
  @ViewChild('overallExporter') overallExporter: any;
    @ViewChild('modelexporter') modelexporter: any;


  constructor(private dataSharingService: DataSharingService,
      private reportsService: ReportsService,
      private MasterService: MasterService,
      private router: Router,
    private route: ActivatedRoute,
      private snackBar: MatSnackBar,
      private lmsService: LmsService) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Cash Flow Report");
    this.route.queryParams.subscribe((params) => {
          this.FyearId = params["fyear"];
          console.log("paran", this.FyearId);
          this.lmsService
            .Get_FinancialYear({ Id: this.FyearId })
            .subscribe((res: any) => {
              this.minDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
              this.maxDate = new Date(moment(res[0].fyent).format("MM/DD/YYYY"));
              this.FromDate = new Date(
                moment(res[0].fystart).format("MM/DD/YYYY")
              );
              if (this.maxDate > new Date() && this.minDate < new Date())
                this.ToDate = new Date();
              else this.ToDate = this.maxDate;
              this.DataSource = null;
              this.DataSourcetop = null;
            });
        });
   
  }
  applyFilter(filterValue: string) {
    this.DataSource.filter = filterValue.trim().toLowerCase();
  }
  DateChange() {
    if (this.FromDate != "" && this.ToDate != "") {
      if (this.FromDate > this.ToDate) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "To Date will be greater than to From Date.",
          ...this.configSuccess,
        });
        this.FromDate = "";
        this.ToDate = "";
      }
    }
  }
   totaltypewise(type) {
    if (
      this.DataSource != null &&
      this.DataSource != undefined &&
      this.DataSource != ""
    ) {
      let sum = 0;
      for (let i = 0; i < this.DataSource.filteredData.length; i++) {
        sum += Number(this.DataSource.filteredData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : 0;
    }
    return 0;
  }

  // onSearchCashData(){
  //    this.showSpinner = true;
  //    this.lmsService.Acc_CashFlow_Data({
  //     DateFrom: this.FromDate,
  //     DateTo: this.ToDate,
  //     Fyear : 2025
  //    }).subscribe((res: any) => {
  //     this.DataSource = res.Item1;
  //     this.DataSourcetop = res.Item2
  //     this.showSpinner = false;
  //   });
  // }
  onSearchCashData() {
  this.showSpinner = true;

  this.lmsService.Acc_CashFlow_Data({
    DateFrom: this.FromDate,
    DateTo: this.ToDate,
    Fyear: this.minDate.getFullYear()
  })
  .subscribe({
    next: (res: any) => {

      // Handle null / undefined
      if (!res || !res.Item1 || res.Item1.length === 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "No data found",
          ...this.configSuccess,
        });
        this.showSpinner = false;
        return;
      }
      this.FileCheckingList = JSON.parse(JSON.stringify(res.Item1));
      this.FileCheckingList1 = JSON.parse(JSON.stringify(res.Item2));


      // Assign data properly
      this.DataSource = new MatTableDataSource(res.Item1);
      this.DataSourcetop = new MatTableDataSource(res.Item2);
       this.IncreaseInApplicationOfFund = res.Item2[0].IncreaseInApplicationOfFund;
      this.DecreaseInApplicationOfFund = res.Item2[0].DecreaseInApplicationOfFund;
      this.IncreaseInSourceOfFund = res.Item2[0].IncreaseInSourceOfFund;
      this.DecreaseInSourceOfFund = res.Item2[0].DecreaseInSourceOfFund;
      // Attach paginator & sort after assigning datasource
      setTimeout(() => {
        this.DataSource.paginator = this.matpaginatorref;
        this.DataSource.sort = this.matSort1;
      });

      this.showSpinner = false;
    },

    error: (err) => {
      console.error("Error loading Fund Flow data:", err);
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Error while fetching data",
        ...this.configSuccess,
      });

      this.showSpinner = false;
    }
  });
}
  onSearchAccountStatement(row) {
        $("#accountingstatement").modal("show");
    $("#accountingstatement").css("z-index", "1050");
        this.showSpinner = true;
          this.lmsService
            .Get_Acc_Leadger({
              AccountId: row.AccountId,
              From: this.FromDate,
              To: this.ToDate,
              StartYear: this.minDate.getFullYear(),
            })
            .subscribe((res: any) => {
              console.log(res);
              if (res.length > 0) {
                this.FileCheckingList = JSON.parse(JSON.stringify(res));
                this.dataSourcemodel = new MatTableDataSource(this.FileCheckingList);
  
                this.dataSourcemodel.sort = this.modelSort;
                this.dataSourcemodel.paginator = this.modelPaginator;
                this.dataSourceExcelmodel = this.FileCheckingList;
                
                setTimeout(() => {
                  $('[data-toggle="tooltip"]').tooltip();
                }, 100);
                this.showSpinner = false;
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: "No data found",
                  ...this.configSuccess,
                });
                this.showSpinner = false;
              }
            });
    }
     OnCloseaccountingstatement() {
    $("#accountingstatement").modal("hide");
  }


  exportOverallTable() {
  this.overallExporter.exportTable('xlsx', { fileName: 'Cash Flow Report' });
  }
  exportmodel(){
    this.modelexporter.exportTable('xlsx', { fileName: 'Cash Flow Account Statement' });
  }
  exportExcel(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "cash-flow"
    ) as HTMLTableElement;
    const worksheetName = "Cash Flow Data"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }


}
